/* eslint-disable */
// Cross-surface "open this lens" bridge (Brief D Phase 3). Dependency-free so the global ⌘K search
// can import it without pulling the lazy Lens Data Base chunk into the main bundle.
// requestOpenLens stashes the lens_no (survives the cold-navigation race where LensBankPage isn't
// mounted yet) AND fires the 'open_lens' event (fast path when the page is already mounted).
// LensBankPage consumes both: it listens for the event, and on mount / lenses-settle it drains any
// pending no via peek/clear.
let _pending = null;

export function requestOpenLens(lensNo) {
  _pending = lensNo || null;
  try { window.dispatchEvent(new CustomEvent('open_lens', { detail: { lens_no: lensNo } })); } catch (_) {}
}
export const peekPendingLens = () => _pending;
export const clearPendingLens = () => { _pending = null; };
